import { reqAllCompanyInfo } from 'src/routes/Apply/services';

export default {
  namespace: 'pendingMessage',
  state: {
    allCompanyInfo: {},
  },
  effects: {
    // 本单位下所有部门信息查询
    *getAllCompanyList({ payload }, { call, put }) {
      const result = yield call(reqAllCompanyInfo, payload);
      const departmentList = result.departmentInfoDtoList?.map(
        i => ({ ...i, deptId: i.departmentId, fullName: `${result.institutionName} ${i.departmentId === -1 ? '' : '- ' + i.departmentName}` }
        ));
      result.departmentList = departmentList;
      yield put({
        type: 'update',
        payload: {
          allCompanyInfo: result || {},
        },
      });
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
